<template>
  <Tabs show-type="show" :route="tabRoute" v-if="viewAllowed">
    <Tab name="Bulk Payouts" :active="true">
      <bulk-payouts />
    </Tab>
    <Tab name="Add Adjustment">
      <adjustments />
    </Tab>
    <Tab name="Publisher Balance Upload">
      <publisher-balance-upload />
    </Tab>
  </Tabs>
</template>

<script>
import BulkPayouts from '@/components/legacy/BulkPayouts/AdminBulkPayouts'
import Adjustments from '@/components/legacy/Adjustments'
import PublisherBalanceUpload from '@/views/Admin/Tools/PublisherBalanceUpload'
import ME_QUERY from '@/graphql/User/MeQuery.gql'

export default {
  components: {
    BulkPayouts,
    Adjustments,
    PublisherBalanceUpload
  },
  props: {
    tab: {
      type: String,
      default: 'bulk-payouts'
    }
  },
  apollo: {
    me: {
      query: ME_QUERY,
      result({ data }) {
        if (data && data.me) {
          this.me = data.me
        }
      }
    },
  },
  computed: {
    viewAllowed() {
      if (
        this.me &&
        this.me.roles &&
        this.me.roles.some(role => role.name !== 'sales-admin-level-1')
      ) {
        return true
      }

      return false
    },
    tabRoute() {
      return { name: 'Tools', params: { tab: this.tab } }
    }
  }
}
</script>

<style></style>
